// extracted by mini-css-extract-plugin
export default {"about":"about_about__MZWk7","about__container":"about_about__container__mWi7E","about__subtitle":"about_about__subtitle__wIz-k","about__info":"about_about__info__z9mXW"};